import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Footer } from "../";
import { getStore } from '../../../../../util/store/store';
import { ACTION_TYPE, SITE_TYPE } from "../../../../../util/varibles/constants";
import { cloneObj } from "../../../../../util/varibles/global";
import { ITransport, IUnit, TOperation } from "../../../../../util/varibles/interface";
import { notify, NotifyCode } from "../../../../../util/varibles/message";
import { selectPlan } from '../../../constants';
import { checkRoute, getKeyUnit } from "../../../util";
import { ErrorName } from "../_components/ErrorOfOperation";
import Units from "../_components/Units";
import { callEventEditOp, getEditOp, useEditOp } from "../EditOperationContext";
import { createTransport, getSubData } from "./constants";
import Operations from "./Operations";
import styles from './style.module.scss';

const Transport: React.FC = () => {
    const [loadingSubmit, set] = useEditOp(state => state.loadingSubmit);
    const operations = useSelector(selectPlan.ops);
    const routeIds = useSelector(selectPlan.routeIds);
    const get = getEditOp();
    const { getActivityLog } = callEventEditOp()

    useEffect(() => {
        const generateState = () => {
            const { operation, vessel, editMode } = get();
            let { store = {} } = selectPlan.popupEdit(getStore()).values || {};
            if (editMode === ACTION_TYPE.CREATE) {
                const { sub_operations = [] } = operation || {};
                const newOperations = sub_operations.reduce((operations: ITransport[], sub) => {
                    const { fish_amount, site_type } = sub;
                    let amountStore = fish_amount;
                    const keyStore = getKeyUnit(sub);
                    const operation_code = `${operations.length}`
                    if (site_type === SITE_TYPE.EXTERNAL) {
                        const { operation } = createTransport({ unit: { ...store[keyStore], fish_amount: 0 }, operation_code }, get)
                        operations.push(operation);
                    } else {
                        let count = 0;
                        while (amountStore > 0) {
                            const { operation, amountStore: newAmountStore } = createTransport({
                                unit: { ...store[keyStore], fish_amount: amountStore },
                                operation_code,
                            }, get)
                            operations.push(operation);
                            amountStore = newAmountStore;
                            count++;

                            if (count === 10)
                                break;
                        }
                    }
                    return operations
                }, [])

                return {
                    isCalculate: true,
                    loadingSubmit: false,
                    ops: newOperations as TOperation[],
                    units: store,
                    count: newOperations.length
                };
            } else {
                let error_detail: any = {};
                if ((operation?.total_weight || 0) > (vessel?.capacity || 0)) {
                    error_detail.weight = notify[NotifyCode.E1]()
                }
                const operations = cloneObj([{ ...operation, error_detail }])
                return {
                    isCalculate: false,
                    loadingSubmit: false,
                    ops: operations,
                    units: store,
                    count: operations.length,
                    init: true
                };
            }
        }
        set(generateState())
    }, [get, set]);

    const addOperation = (unit: IUnit) => {
        const { operation } = createTransport({ unit }, get)
        set(({ ops: prevOps, count: prevCount }) => ({ ops: [...prevOps || [], operation as TOperation], count: prevCount + 1 }))
    }

    const handleSubmit = () => {
        const { isCalculate, ops: dataNew } = get();
        if (isCalculate) {
            const isError = checkError();
            const { vessel, activity_log, operation } = get()
            if (isError || !vessel) return;

            const { id: opId = 0 } = operation || {};
            const properties: any = { [opId]: { start: activity_log[0].est_start_time } };
            const operations = dataNew.map((item: any, index: number) => {
                const { sub_operations, sub_destinations } = getSubData(item);
                properties[index] = {
                    ...properties[index] || {},
                    start_place: dataNew[index - 1]
                        ? { start_place_id: dataNew[index - 1].factory_id, start_place_field: 'factory', }
                        : undefined
                }

                return {
                    operation: { ...item, sub_operations, sub_destinations, },
                    vessel
                }
            })
            getActivityLog({ source: operations, properties })
        } else {
            const operation = dataNew[0];
            const { id } = dataNew[0];
            const { onSave } = get();
            onSave({ update: { [id]: { ...operations[id], operation } }, isCheck: false });
        }
    };

    const checkError = () => {
        const { ops } = get();
        let isError = false;
        const operationsAfterCheck = ops.reduce((list: any, item: any) => {
            let {
                sub_destinations,
                error_detail = {},
                source_id,
                source_name,
                destination_id,
                destination_name
            } = item;

            let error = sub_destinations.some((sub: any) => sub.fish_amount === 0 || sub.total_weight === 0)
            if (error) {
                isError = true;
                error_detail[ErrorName.FishAmount] = notify[NotifyCode.E37](['Fish amount, total weight']);
            }

            if (destination_id) {
                error = sub_destinations.some((sub: any) => !sub.delivery_id)
                if (error) {
                    isError = true
                    error_detail[ErrorName.DeliveryId] = 'Deliv. unit is required field';
                }

                const validRoute = checkRoute({ id: source_id, name: source_name }, {
                    id: destination_id,
                    name: destination_name
                }, routeIds);
                if (validRoute.error === 2) {
                    isError = true;
                    error_detail[ErrorName.Route] = [{
                        source_id: source_id,
                        destination_id,
                        message: validRoute.message
                    }];
                }
            } else {
                isError = true
                error_detail[ErrorName.DestinationId] = 'Deliv. site is required field';
            }

            return [...list, { ...item, error_detail }];
        }, []);
        if (isError)
            set({ ops: operationsAfterCheck })
        return isError;
    }

    return <div className={styles['container-body']}>
        <Units
            addOperation={addOperation}
            nameRow={(data: any) => <span>{[data.site_name, data.unit_id].join(', ')}</span>}
        >
            <span>Smolt site</span>
        </Units>
        <div className={styles['title-table']}>
            Delivery info.
        </div>
        <Operations />
        <Footer {...{
            loading: loadingSubmit,
            handleSubmit,
        }} />
    </div>
};

export default Transport;